module.exports = {
  url: '/team/:division',
  template: require('raw!templates/team/team.html'),
  controller: TeamController,
  controllerAs: 'teamCtrl',
  params: {
    // 'division': null,
  }
}

function TeamController($scope, $state, store, contentful, $uibModal, $window, $q, $sce, Slug) {
  	$window.scrollTo(0, 0);
    var vm = this;
    $scope.trustSrc = function(src) {
return $sce.trustAsResourceUrl(src);
}
  $scope.slide = {
    'teamNav': true
  }

  $scope.filteredMembers= [
    [],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]
  ],
  $scope.setCurrentTeamMember = function (member) {
    $scope.currentTeamMember = member
  }
  $scope.mainPage = 'team'

  contentful.entries('content_type=team').then(function(res) {
		var seoData = res.data.items[0];
		if (seoData.fields.pageTitle) {
			document.title = seoData.fields.pageTitleSeo;
		}
		if (seoData.fields.pageSpecificMetaDescriptionSeo) {
			var meta = document.getElementsByTagName("meta");
			for (var i = 0; i < meta.length; i++) {
				if (meta[i].name.toLowerCase() === "description") {
					meta[i].content = seoData.fields.pageSpecificMetaDescriptionSeo;
				}
			}
		}
	})

  contentful.entries('content_type=teamMembers').then(function(res) {
      $scope.teamMember = res.data.items[0];
	})

  contentful.entries('content_type=team').then(function(res) {
    $scope.teamPage = res.data.items[0];
  })

  $state.params.all = 'All'

  if($state.params.division) {
    $scope.currentDivision = ($state.params.division)
    if ($scope.currentDivision === "Architecture") {
    } else {
      // console.log('Current Division', $scope.currentDivision );
    }
  } else {
    $scope.currentDivision = "All"
  }
  $scope.page = $scope.currentDivision;
  $scope.division = Slug.slugify($scope.currentDivision);
  // console.log('division', $scope.division);

  function comparePriority(a,b) {
    if (a.fields.priority < b.fields.priority)
      return -1;
    if (a.fields.priority > b.fields.priority)
      return 1;
    return 0;
  }

  function sortMembers(members) {
    var deferred = $q.defer();
    var sortedMemberCache = []
    angular.forEach(members, function(member){
      sortedMemberCache.push(member)
      sortedMemberCache.sort(comparePriority)
    })
    deferred.resolve(sortedMemberCache)
    return deferred.promise;
  }

  if($scope.currentDivision) {
    contentful.entries('content_type=teamMembers&include=3').then(function(res) {
      var items = res.data.items
      var index = 1
      var switchAt = 4
      var arrayVal = 0
      sortMembers(items).then(function(sortedMembers){
        angular.forEach(sortedMembers, function(member){
          if(member.fields.all){
            if(member.fields.all === $scope.currentDivision) {
              if(switchAt === 4) {
                if(index < switchAt) {
                  $scope.filteredMembers[arrayVal].push(member)
                  index ++
                } else {
                  switchAt = 3
                    $scope.filteredMembers[arrayVal].push(member)
                  index = 1
                  arrayVal ++
                }
              } else if (switchAt === 3) {
                if(index < switchAt) {
                  $scope.filteredMembers[arrayVal].push(member)
                  index ++
                } else {
                  switchAt = 4
                    $scope.filteredMembers[arrayVal].push(member)
                  index = 1
                  arrayVal ++
                }
              }
            }
          }
        })
      })
      sortMembers(items).then(function(sortedMembers){
        angular.forEach(sortedMembers, function(member){
          if (member.fields.fullImage) {
              $scope.image = $sce.trustAsResourceUrl(member.fields.fullImage.fields.file.url);
            }
          if(member.fields.division){
            if(member.fields.division === $scope.currentDivision) {
              if(switchAt === 4) {
                if(index < switchAt) {
                  $scope.filteredMembers[arrayVal].push(member)
                  index ++
                } else {
                  switchAt = 3
                    $scope.filteredMembers[arrayVal].push(member)
                  index = 1
                  arrayVal ++
                }
              } else if (switchAt === 3) {
                if(index < switchAt) {
                  $scope.filteredMembers[arrayVal].push(member)
                  index ++
                } else {
                  switchAt = 4
                    $scope.filteredMembers[arrayVal].push(member)
                  index = 1
                  arrayVal ++
                }
              }
            }
          }
          if(member.fields.division2){
            if(member.fields.division2 === $scope.currentDivision ) {
              if(switchAt === 4) {
                if(index < switchAt) {
                  $scope.filteredMembers[arrayVal].push(member)
                  index ++
                } else {
                  switchAt = 3
                    $scope.filteredMembers[arrayVal].push(member)
                  index = 1
                  arrayVal ++
                }
              } else if (switchAt === 3) {
                if(index < switchAt) {
                  $scope.filteredMembers[arrayVal].push(member)
                  index ++
                } else {
                  switchAt = 4
                    $scope.filteredMembers[arrayVal].push(member)
                  index = 1
                  arrayVal ++
                }
              }
            }
          }
          if(member.fields.division3){
            if(member.fields.division3 === $scope.currentDivision ) {
              if(switchAt === 4) {
                if(index < switchAt) {
                  $scope.filteredMembers[arrayVal].push(member)
                  index ++
                } else {
                  switchAt = 3
                    $scope.filteredMembers[arrayVal].push(member)
                  index = 1
                  arrayVal ++
                }
              } else if (switchAt === 3) {
                if(index < switchAt) {
                  $scope.filteredMembers[arrayVal].push(member)
                  index ++
                } else {
                  switchAt = 4
                    $scope.filteredMembers[arrayVal].push(member)
                  index = 1
                  arrayVal ++
                }
              }
            }
          }
          if(member.fields.division4){
            if(member.fields.division4 === $scope.currentDivision ) {
              if(switchAt === 4) {
                if(index < switchAt) {
                  $scope.filteredMembers[arrayVal].push(member)
                  index ++
                } else {
                  switchAt = 3
                    $scope.filteredMembers[arrayVal].push(member)
                  index = 1
                  arrayVal ++
                }
              } else if (switchAt === 3) {
                if(index < switchAt) {
                  $scope.filteredMembers[arrayVal].push(member)
                  index ++
                } else {
                  switchAt = 4
                    $scope.filteredMembers[arrayVal].push(member)
                  index = 1
                  arrayVal ++
                }
              }
            }
          }
          if(member.fields.division5){
            if(member.fields.division5 === $scope.currentDivision ) {
              if(switchAt === 4) {
                if(index < switchAt) {
                  $scope.filteredMembers[arrayVal].push(member)
                  index ++
                } else {
                  switchAt = 3
                    $scope.filteredMembers[arrayVal].push(member)
                  index = 1
                  arrayVal ++
                }
              } else if (switchAt === 3) {
                if(index < switchAt) {
                  $scope.filteredMembers[arrayVal].push(member)
                  index ++
                } else {
                  switchAt = 4
                    $scope.filteredMembers[arrayVal].push(member)
                  index = 1
                  arrayVal ++
                }
              }
            }
          }
          if(member.fields.division6){
            if(member.fields.division6 === $scope.currentDivision ) {
              if(switchAt === 4) {
                if(index < switchAt) {
                  $scope.filteredMembers[arrayVal].push(member)
                  index ++
                } else {
                  switchAt = 3
                    $scope.filteredMembers[arrayVal].push(member)
                  index = 1
                  arrayVal ++
                }
              } else if (switchAt === 3) {
                if(index < switchAt) {
                  $scope.filteredMembers[arrayVal].push(member)
                  index ++
                } else {
                  switchAt = 4
                    $scope.filteredMembers[arrayVal].push(member)
                  index = 1
                  arrayVal ++
                }
              }
            }
          }
        })
      })
    })
  }
}



/** WEBPACK FOOTER **
 ** ./components/templates/team/team.js
 **/